export default function AVERAGE() {
  return <div>Excel_AVERAGE</div>;
}
